<template>
  <div class="home">
    <EmployeeDepartmentList v-show="listView" @newDepartment="onClickNewFromList" @editDepartment="onClickEditFromList" ref="refreshList"/>
    <EmployeeDepartmentForm v-show="formView" :department="department" @backClicked="onBackChild" @backParentID="backParentID"/>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import EmployeeDepartmentList from '@/components/employee/EmployeeDepartmentList.vue'
import EmployeeDepartmentForm from '@/components/employee/EmployeeDepartmentForm.vue'
import { getHeader, employeeUrl } from '../config'

export default {
  name: 'EmployeeDepartment',
  components: {
    EmployeeDepartmentList,
    EmployeeDepartmentForm
  },
  data () {
    return {
      listView: true,
      formView: false,
      department: {
        id: null,
        name: null,
        company_no: null
      }
    }
  },
  methods: {
    backParentID: function (id) {
      axios.get(employeeUrl + '/department/' + id, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.department = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    onClickEditFromList: function (value) {
      this.listView = false
      this.formView = true
      this.department = value
    },
    getEdit: function (value) {
      console.log(employeeUrl + '/department/' + value)
      axios.get(employeeUrl + '/department/' + value, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.listView = false
          this.formView = true
          this.department = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      this.listView = false
      this.formView = true
      this.department = {
        id: null,
        name: null,
        company_no: null
      }
    },
    onBackChild: function () {
      this.listView = true
      this.formView = false
      this.department = {
        id: null,
        name: null,
        company_no: null
      }
      this.$refs.refreshList.refreshList()
      // this.$router.replace({ path: 'sales', query: null })
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getRowTable')
  }
}
</script>
